/**
 * Get the allowed origin for CORS requests based on the current hostname.
 * @returns The allowed origin URL as a string.
 */
export const getAllowedOrigin = () => {
  switch (true) {
    /**
     * For our local development, we need to allow requests
     * from the alias we have created in our etc hosts file.
     */
    case window.location.hostname?.endsWith('.local'):
      return 'https://paymentform';
    case window.location.hostname?.endsWith('edreams.com'):
      return 'https://www.edreams.net';
    default:
      return 'https://www.edreams.com';
  }
};
